export default {
  routePg: "",
  pg:0
}